import { useTranslation } from "react-i18next";
import { Close } from "@dreamhub/designsystem/icons";
import { Button } from "@/components/ui/button";
import { IconButton } from "@/components/ui/icon-button";
import ToastBody from "@/components/ui/toast-body";
import { TRANSLATION_KEY } from "@/components/global/Chat/components/dreamerReports/consts";

interface ReportRunToastProps {
  message: string;
  onOpenReport: () => void;
  onDismiss: () => void;
}

/** Tells a user with the chat open that a report run finished, with a way to it. */
export const ReportRunToast: React.FC<ReportRunToastProps> = ({
  message,
  onOpenReport,
  onDismiss
}) => {
  const { t } = useTranslation();

  return (
    <ToastBody
      title={message}
      actions={
        <>
          <Button
            variant="secondary"
            onClick={() => {
              onOpenReport();
              onDismiss();
            }}
            data-test="report-run-toast-open"
          >
            {t(`${TRANSLATION_KEY}.runNotice.open`)}
          </Button>
          <IconButton
            variant="iconNoBg"
            iconColor="secondary"
            size="md"
            onClick={onDismiss}
            aria-label={t("close")}
          >
            <Close />
          </IconButton>
        </>
      }
    />
  );
};
